module.exports = __webpack_public_path__ + "img/water-percent.759ce35b.svg";